import { Children } from 'react';
export const getChildrenByType = (type, children) => Children.toArray(children).filter( // eslint-disable-next-line @typescript-eslint/no-explicit-any
node => node.type._type === type);